var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: !_vm.editMode ? "student-admission-detail-board-main" : "",
      attrs: { id: "student-admission-detail-board-main" }
    },
    [
      _vm.showBoard
        ? _c(
            "div",
            {
              staticClass: "bg-secondary-3 p-4 rounded-lg",
              class: _vm.isMobile && "h-100"
            },
            [
              !_vm.editMode
                ? _c("div", { staticClass: "pb-3" }, [
                    _vm.isAdmissionCoordination || _vm.isCoordination
                      ? _c("i", {
                          staticClass:
                            "far fa-check p-2 rounded-circle bg-white text-orange shadow-sm"
                        })
                      : _vm._e(),
                    _vm.isTransfer
                      ? _c("i", {
                          staticClass:
                            "far fa-arrow-circle-right p-2 rounded-circle bg-white text-orange shadow-sm"
                        })
                      : _vm._e(),
                    _vm.isAdmissionCoordination
                      ? _c(
                          "span",
                          {
                            staticClass: "font-weight-bold fs-16 text-dark-gray"
                          },
                          [_vm._v(" Confirmar Admisión ")]
                        )
                      : _vm._e(),
                    _vm.isCoordination
                      ? _c(
                          "span",
                          {
                            staticClass: "font-weight-bold fs-16 text-dark-gray"
                          },
                          [_vm._v(" Coordinar Servicio ")]
                        )
                      : _vm._e(),
                    _vm.isTransfer
                      ? _c(
                          "span",
                          {
                            staticClass: "font-weight-bold fs-16 text-dark-gray"
                          },
                          [_vm._v(" Traslado Interno ")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              !_vm.editMode
                ? _c(
                    "div",
                    {
                      staticClass: "bg-white rounded-lg p-2",
                      class: { "col-4": !_vm.isOpen }
                    },
                    [
                      _c("div", { staticClass: "row py-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col pl-4 d-flex align-items-center",
                            class: {
                              "border-right mr-5": _vm.isOpen && !_vm.isMobile
                            }
                          },
                          [
                            _c("div", { staticClass: "d-flex flex-column" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-gray-6 font-weight-normal fs-14"
                                },
                                [_vm._v(" Estudiante: ")]
                              ),
                              _c(
                                "p",
                                { staticClass: "font-weight-bold fs-16" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.value.fullName) +
                                      " - " +
                                      _vm._s(_vm.value.studentSieId) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm.isOpen
                          ? _c("div", { staticClass: "col-md-9" }, [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12 col-lg-2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Edad: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.value.studentAge) +
                                          " años "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "col-12 col-lg-2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Número de Referido: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.value.referralNumber) +
                                          " "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "col-12 col-lg" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Código-Escuela: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [_vm._v(_vm._s(_vm.value.place))]
                                  )
                                ]),
                                _c("div", { staticClass: "col-12 col-lg" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Impedimento: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [_vm._v(_vm._s(_vm.value.impediment))]
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12 col-lg-2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Frecuencia: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [_vm._v(_vm._s(_vm.value.frequency))]
                                  )
                                ]),
                                _c("div", { staticClass: "col-12 col-lg-2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Modalidad: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.value.modalityTypeName) +
                                          " "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "col-12 col-lg" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 font-weight-normal fs-14"
                                    },
                                    [_vm._v(" Duración: ")]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "font-weight-bold fs-16" },
                                    [_vm._v(_vm._s(_vm.value.duration))]
                                  )
                                ]),
                                (_vm.isAdmissionCoordination ||
                                  _vm.isCoordination) &&
                                !_vm.editMode
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg d-flex align-items-center"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "d-flex flex-column" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 rounded-pill p-2 px-3 text-white pointer",
                                                class: {
                                                  "bg-success": _vm.isCompleted,
                                                  "bg-orange": !_vm.isCompleted
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.isOpen = false
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-check-circle pr-1",
                                                  class: {
                                                    fa: _vm.isCompleted,
                                                    far: !_vm.isCompleted
                                                  }
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.spacesQuantity) +
                                                    "/" +
                                                    _vm._s(
                                                      _vm.frequencyNumber
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isTransfer && !_vm.editMode
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12 col-lg" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-gray-6 font-weight-normal fs-14"
                                          },
                                          [_vm._v(" Fecha de Efectividad: ")]
                                        ),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "validation-observer",
                                              { ref: "requestDateObserver" },
                                              [
                                                _c("validation-provider", {
                                                  attrs: { rules: "required" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function({
                                                          errors
                                                        }) {
                                                          return [
                                                            _c(
                                                              "custom-date-picker",
                                                              {
                                                                attrs: {
                                                                  "custom-error-msg":
                                                                    "La fecha es requerida.",
                                                                  error:
                                                                    errors[0],
                                                                  "max-date":
                                                                    _vm.maxDate,
                                                                  "min-date":
                                                                    _vm.minDate
                                                                },
                                                                on: {
                                                                  onSelectedDate: data =>
                                                                    _vm.$emit(
                                                                      "onSelectedDate",
                                                                      data
                                                                    )
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.requestDate,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.requestDate = $$v
                                                                  },
                                                                  expression:
                                                                    "requestDate"
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    1540018598
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-2 pl-0 d-flex align-items-center"
                              },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-plus-circle",
                                    variant: "outline-success pl-3 pr-3"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.isOpen = true
                                    }
                                  }
                                })
                              ],
                              1
                            )
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "bg-white rounded-lg p-4 mt-4",
                  class: { "d-none": !_vm.isOpen }
                },
                [
                  !_vm.isRemoving
                    ? _c("div", { staticClass: "row my-1" }, [
                        _c("div", { staticClass: "col-12 col-lg-6 col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                { staticClass: "col-lg-8 col-md-6" },
                                [
                                  _vm._v(
                                    " ¿Este servicio sera ofrecido por un practicante/interno? "
                                  )
                                ]
                              ),
                              _c("custom-radio-group", {
                                staticClass: "col-lg-4 col-md-6",
                                attrs: {
                                  "field-key": "value",
                                  "is-inline": true,
                                  name: "claimTypes",
                                  options: [
                                    { value: true, label: "Sí" },
                                    { value: false, label: "No" }
                                  ]
                                },
                                on: { input: _vm.onisPractitionerChange },
                                model: {
                                  value: _vm.isPractitioner,
                                  callback: function($$v) {
                                    _vm.isPractitioner = $$v
                                  },
                                  expression: "isPractitioner"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm.isPractitioner
                          ? _c(
                              "div",
                              { staticClass: "col-12 col-lg-3" },
                              [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    fieldkey: "id",
                                    fieldname: "name",
                                    options: _vm.interns,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.practitioner,
                                    callback: function($$v) {
                                      _vm.practitioner = $$v
                                    },
                                    expression: "practitioner"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.editMode && !_vm.isRemoving
                    ? _c("div", { staticClass: "my-1 row" }, [
                        _c("div", { staticClass: "col-12 col-lg-6 col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                { staticClass: "col-lg-8 col-md-6" },
                                [
                                  _vm._v(
                                    " ¿Desea modificar el horario y día de toda la sesión grupal? "
                                  )
                                ]
                              ),
                              _c("custom-radio-group", {
                                staticClass: "col-lg-4 col-md-6",
                                attrs: {
                                  "field-key": "value",
                                  "is-inline": true,
                                  name: "editOptions",
                                  options: [
                                    { value: true, label: "Sí" },
                                    { value: false, label: "No" }
                                  ]
                                },
                                on: { input: _vm.onEditModeInGroupChange },
                                model: {
                                  value: _vm.isEditModeInGroup,
                                  callback: function($$v) {
                                    _vm.isEditModeInGroup = $$v
                                  },
                                  expression: "isEditModeInGroup"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.isRemoving
                    ? _c("div", { staticClass: "my-1 row" }, [
                        _c("div", { staticClass: "col-12 col-lg-6 col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "label",
                                { staticClass: "col-lg-8 col-md-6" },
                                [
                                  _vm._v(
                                    " ¿Desea Eliminar el espacio de toda la sesión grupal? "
                                  )
                                ]
                              ),
                              _c("custom-radio-group", {
                                staticClass: "col-lg-4 col-md-6",
                                attrs: {
                                  "field-key": "value",
                                  "is-inline": true,
                                  name: "removeOptions",
                                  options: [
                                    { value: true, label: "Sí" },
                                    { value: false, label: "No" }
                                  ]
                                },
                                on: { input: _vm.onRemoveModeInGroupChange },
                                model: {
                                  value: _vm.isRemoveModeInGroup,
                                  callback: function($$v) {
                                    _vm.isRemoveModeInGroup = $$v
                                  },
                                  expression: "isRemoveModeInGroup"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }